import angular from 'angular';
import { VariableSelectBridge } from './VariableSelectBridge';

angular
  .module('flowingly.components')
  .component('variableSelect', VariableSelectBridge);
